<app-layout>
  <p-toast />

  <div class="m-5 block">
    <div class="mb-3 form-container">
      <div class="form-item form-header">
        <h2 class="mb-4">
          <i class="pi pi-file-edit fw-bold text-dark" style="font-size: 25px"></i>
          Responder formulario
        </h2>

        <div class="form-group mt-6">
          <label class="form-label">Título del formulario:</label>
          <p class="form-input-title">{{ title }}</p>
        </div>
      </div>

      <div *ngFor="let answer of answers.controls; let i = index" [formGroup]="answer" class="question-block">
        <div class="question-item">
          <label class="form-label">
            Pregunta {{ i + 1 }}:
          </label>
          <p class="form-input-question">{{ answer.get('question')?.value }}</p>
        </div>

        <div class="options">
          <div *ngFor="let option of getPosiblesArray(answer).controls; let j = index" class="option">
            <input type="radio" [value]="j" formControlName="selectedIndex" />
            <!-- [name]="'selectedIndex-' + i" -->
            <p>{{ option.value }}</p>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" (click)="submitForm()" class="mt-4 form-action-button save-button">
          Guardar
        </button>

        <button type="button" (click)="cancel()" class="mt-4 form-action-button cancel-button">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</app-layout>
